import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtText from "../../../components/NtText";
import NtSectionButton from "../general/NtSectionButton";
import { useNavigation } from "@react-navigation/native";
import routes from "../../../navigation/routes";
import { useMobile } from "../../../hooks/useMobile";

function NtHomeSection(props) {
  const nav = useNavigation();
  const isMobile = useMobile();
  const renderBox = (
    image,
    title,
    subtitle,
    price,
    buttonTitle,
    onPress,
    containerStyle
  ) => {
    return (
      <View
        style={[
          {
            flex: 1,
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            padding: 10,
            borderRadius: 10,
            borderWidth: 1,
            borderColor: "rgba(255, 255, 255, 0.1)",
            flexDirection: "row",
            // alignItems: "center",
            maxWidth: 500,
          },
          containerStyle,
        ]}
      >
        <Image
          style={[
            {
              width: 130,
              height: 130,
              borderRadius: 10,
            },
          ]}
          source={image}
        />

        <View
          style={{
            marginLeft: 10,
            alignItems: "flex-start",
            flex: 1,
          }}
        >
          <NtText style={{ color: "white", fontSize: 11, fontWeight: 300 }}>
            {title}
          </NtText>
          <NtText
            style={{
              color: "white",
              marginTop: 10,
              fontWeight: 600,
              fontSize: 16,
              flex: 1,
            }}
          >
            {subtitle}
          </NtText>
          <NtText
            style={{
              color: "white",
              fontSize: 11,
              fontWeight: 300,
              marginTop: 10,
            }}
          >
            {price}
          </NtText>

          <NtSectionButton
            containerStyle={{ marginTop: 10 }}
            title={buttonTitle}
            onPress={onPress}
            color="white"
          />
        </View>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/0b3e04a5d06b70d4d5cd43c72f8de0309c04f2c7.png")}
    >
      <NtSectionTitle style={{ fontSize: 28, marginTop: 150 }}>
        MISSION CRITICAL COMMUNICATIONS FOR A CONNECTED WORLD
      </NtSectionTitle>

      <View
        style={[
          {
            marginTop: 50,
            flexDirection: isMobile ? "column" : "row",
          },
          isMobile ? { alignItems: "center" } : { justifyContent: "center" },
        ]}
      >
        {renderBox(
          require("../../../assets/images/marketing/B6D984A4-40E6-49B9-B864-03A1F03A69A1.png"),
          "PERSONAL PHONE",
          "Your Personal Line. Free Nationwide Calling. No Strings Attached",
          "As low as $9/mo",
          "Plans",
          () => {
            nav.navigate(routes.plans);
          },
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 }
        )}

        {renderBox(
          require("../../../assets/images/marketing/73515DC7-F295-42AB-97C6-9C41DC47B642.png"),
          "BUSINESS PHONE",
          "Cloud PBX. Built for Business. Free from Contracts. ",
          "As low as $12.97/mo",
          "Learn more",
          () => {
            nav.navigate(routes.business);
          }
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 650,
  },
});

export default NtHomeSection;
